module.exports = __webpack_public_path__ + "static/media/coin20.c3bd1b7f.png";